module.exports = __webpack_public_path__ + "img/icon_room_status.b22f3aa6.png";